export const LOG_ERROR = 'actions/error/LOG_ERROR';

export const logError = (payload) => ({type: LOG_ERROR, payload});
